import { executeRequest, JFSRequest } from '@jfs/network'
import { isSuccessResponse } from '../utils'
import { APIEndPoints } from './APIEndPoints'
import { getHeaders, getUrl, sitConfig } from './config'

const responseParser = (response: any) => {
  return isSuccessResponse(response)
}

const getRequest = (data: any) => {
  return {
    approvalId: data.id, // 0
    approvalType: data.type, // 'DELETE_APPROVAL',
    status: data.status, // true/false
  }
}

const riskControlMerchantProcessApproval = (data: any, tokens: any) => {
  const request: JFSRequest<{}> = {
    apiPath: getUrl(APIEndPoints.riskControlMerchantProcessApproval),
    method: 'POST',
    config: sitConfig(tokens),
    headers: getHeaders(),
    body: {
      ...getRequest(data),
    },
  }

  return executeRequest(request)
    .then(responseParser)
    .catch((error) => {
      throw error
    })
}

export { riskControlMerchantProcessApproval }
